import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuth } from "_hooks";
import { Base } from "components/template";
import { InputControl } from "components/organism";
import { Button } from "components/atoms";
import { newPasswordSchema } from "_config/formSchemas";

const prefix = "v-new-password";

const NewPassword = () => {
  const { createPassword, createPasswordData, createPasswordIsLoading, createPasswordReset } = useAuth();
  const { formState: { errors, dirtyFields }, handleSubmit, register, trigger, watch } = useForm({
    resolver: yupResolver(newPasswordSchema)
  });
  const navigate = useNavigate();
  const { token } = useParams();

  const watchFields = watch();

  const onSubmit = ({ password }) => createPassword(token, { password });

  const redirect = useCallback(() => {
    navigate("/account/login");
  }, [navigate]);

  useEffect(() => {
    return () => {
      createPasswordReset();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (createPasswordData !== null) redirect();
  }, [createPasswordData, redirect]);

  return (
    <Base>
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-3">
          <p className="text-center text-2xl font-bold mx-auto mb-10">Crea tu nueva contraseña</p>

          <form 
            className="flex flex-wrap gap-3"
            onSubmit={handleSubmit(onSubmit)}
          >
            <InputControl
              errors={errors?.password}
              inputProps={{
                autoComplete: "off",
                placeholder: "****",
                type: "password",
                ...register("password")
              }}
              name="password"
              label={"Nueva contraseña"}
              onChange={() => {
                trigger(["password"]);
                if (dirtyFields?.confirm) trigger(["confirm"])
              }}
              orientation="vertical"
              showErrors={false}
            />

            <InputControl
              errors={errors?.confirm}
              className="mb-5"
              inputProps={{
                placeholder: "****",
                type: "password",
                ...register("confirm")
              }}
              label={"Confirmar nueva contraseña"}
              name="confirm"
              onChange={() => {
                if (dirtyFields?.password) trigger(["confirm"])
              }}
              orientation="vertical"
              showErrors={false}
            />

            <div className={`${prefix}__rules mb-5`}>
              <ul className="list-disc list-inside">
                <li
                  className={dirtyFields?.password && dirtyFields?.confirm && `text-${watchFields?.password === watchFields?.confirm ? "green-500": "red-700"}`}
                >
                  Las contraseñas coinciden
                </li>
                <li
                  className={dirtyFields?.password && `text-${/.{8,}$/.test(watchFields?.password) ? "green-500": "red-700"}`}>Tiene al menos 8 caracteres</li>
                <li className={dirtyFields?.password && `text-${/(?=.*[0-9])/.test(watchFields?.password) ? "green-500": "red-700"}`}>Tiene un número (0-9)</li>
                <li className={dirtyFields?.password && `text-${/(?=.*[#/¡!-.¿?])/.test(watchFields?.password) ? "green-500": "red-700"}`}>Tiene un caracter especial (#/¡!-.¿?)</li>
              </ul>
            </div>
            <Button
              disabled={createPasswordIsLoading || createPasswordData}
              fullwidth
              height={10}
              pulse
              type="submit"
              className="bg-primary text-white rounded-lg"
            >
              Continuar
            </Button>
          </form>
        </div>
      </div>
    </Base>
  );
};

export default NewPassword;
